<template>
  <PageLayout>
    <v-row>
      <v-col :sm="12">
        <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-4">
          Tutoriály
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col :xs="6" :md="4" :lg="3">
        <v-card flat class="tutorialCard">
          <iframe
            src="https://player.vimeo.com/video/624112058?h=0fd4b89492"
            width="378"
            height="200"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>

          <v-card-title class="navy--text text--darken-1 font-weight-bold py-3"
            >Založení a nastavení business manageru</v-card-title
          >
        </v-card>
      </v-col>
    </v-row>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/home/PageLayout"

export default {
  name: "Tutorials",
  components: {
    PageLayout,
  },
}
</script>

<style scoped>
.tutorialCard {
  transition: all 0.3s;
}

.tutorialCard:hover {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
}
</style>
